const translations = {
  title: 'Cuestionarios',
  'menu.import': 'Importar',
  'menu.importHistory': 'Historial de importación',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Historial de exportación',
  'menu.category': 'Registro de categorías',
  name: 'Nombre',
  actions: 'Acciones',
  availableIn: 'Disponible en',
  type: 'Tipo',
  updatedAt: 'Última actualización',
  enabled: 'Activado',
  searchOnlyThisEnvironment: 'Buscar solo en este entorno',
  searchOnlyThisEnvironmentTooltip:
    'Por defecto, la búsqueda se realiza en la base de plantillas. Al activar esta opción, la búsqueda se realizará solo en este entorno.',
  createNew: 'Crear uno nuevo',
  createNewDescription: 'Nuevo cuestionario en blanco.',
  new: 'Nuevo',
  templates: 'Plantillas'
}

export default translations
